import type { ComponentProps } from 'react';

import { Link } from '@change-corgi/design-system/components/actions';
import { Avatar } from '@change-corgi/design-system/components/media';
import { Box, Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import { useDecisionMakerResponseByLine } from './hooks/useDecisionMakerResponseByLine';

// using this trick to avoid clipping of the first letter (due to Noto-Sans' design)
const clippingFixStyles = {
	paddingLeft: 8,
	marginLeft: -8,
};

const AVATAR_MARGIN = 12;
const AVATAR_SIZE = 40;

export function DecisionMakerResponseByLine(props: ComponentProps<typeof Box>) {
	const {
		data: { author },
	} = useDecisionMakerResponseByLine();

	return (
		<Flex sx={{ alignItems: 'center' }} {...props}>
			<Avatar variant="subtle" src={author.photoUrl} alt="" size={AVATAR_SIZE} mr={AVATAR_MARGIN} />
			<Box sx={{ flex: 1 }}>
				<Text
					as="div"
					color="typography-primary"
					size="small"
					sx={{
						fontWeight: 'bold',
						...clippingFixStyles,
					}}
					ellipsis
				>
					{author.profileUrl ? <Link to={author.profileUrl}>{author.displayName}</Link> : author.displayName}
				</Text>
				{author.title && (
					<Text as="div" color="typography-primary" size="small" sx={clippingFixStyles} ellipsis>
						{author.title}
					</Text>
				)}
			</Box>
		</Flex>
	);
}
